import { AgentApprovalQueue } from "@/components/agents/runs/agent-approval-queue.tsx";
import { linkedApprovalTarget } from "@/components/agents/runs/approval-link.ts";
import { approvalLinkSearchSchema } from "@/shared/agent-approval-link.ts";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/dashboard/agents/approvals",
)({
	validateSearch: approvalLinkSearchSchema,
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_approvals_title()) }],
	}),
});

function RouteComponent() {
	const search = Route.useSearch();
	return <AgentApprovalQueue linked={linkedApprovalTarget(search)} />;
}
